import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const NoFoundPage: React.FC = () => (
  <Result
    status="404"
    title="404"
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        Go Back
      </Button>
    }
  />
);

export default NoFoundPage;
